class EncryptionService {
  constructor (encryptionKey) {
    this.key = encryptionKey
  }

  encrypt (plainText, crypto) {
    const iv = crypto.randomBytes(12)

    const cipher = crypto.createCipheriv('aes-256-gcm', this.key, iv)

    const encrypted = Buffer.concat([
      cipher.update(plainText, 'utf8'),
      cipher.final()
    ])

    const authTag = cipher.getAuthTag()

    // Store IV + AuthTag + Ciphertext
    return Buffer.concat([iv, authTag, encrypted]).toString('base64')
  }

  decrypt (encryptedData, crypto) {
    if (!encryptedData) {
      return null
    }
    const data = Buffer.from(encryptedData, 'base64')

    const iv = data.subarray(0, 12)
    const authTag = data.subarray(12, 28)
    const encrypted = data.subarray(28)

    const decipher = crypto.createDecipheriv('aes-256-gcm', this.key, iv)
    decipher.setAuthTag(authTag)

    const decrypted = Buffer.concat([
      decipher.update(encrypted),
      decipher.final()
    ])

    return decrypted.toString('utf8')
  }
}

module.exports = { EncryptionService }
